import React, { Profiler } from 'react';

const readPerfFlag = () => {
  if (process.env.NODE_ENV === 'production') return false;
  try { return window.localStorage.getItem('qv4_perf') === '1'; } catch { return false; }
};
let perfFlag = readPerfFlag();
if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'production') {
  window.addEventListener('storage', event => { if (event.key === null || event.key === 'qv4_perf') perfFlag = readPerfFlag(); });
}
// Read once at load (and on cross-tab storage changes): this runs on every card render and reducer dispatch.
export const perfEnabled = () => perfFlag;
export const refreshPerfFlag = () => { perfFlag = readPerfFlag(); return perfFlag; };
let metrics = { commits: 0, workflowRenders: 0, chatRenders: 0, reducerSamples: [], messages: 0, conversations: 0 };
export const resetPipelineMetrics = () => { metrics = { commits: 0, workflowRenders: 0, chatRenders: 0, reducerSamples: [], messages: 0, conversations: 0 }; };
export const pipelineMetrics = () => metrics;
export function recordPipelineRender(id) {
  metrics.commits += 1;
  if (id.startsWith('WorkflowCard:')) metrics.workflowRenders += 1;
  if (id.startsWith('ChatRow:')) metrics.chatRenders += 1;
}
export const profilePipeline = (id, children) => perfEnabled() ? <Profiler id={id} onRender={recordPipelineRender}>{children}</Profiler> : children;
export function recordPipelineReduction(state, duration) {
  if (!perfEnabled()) return;
  metrics.messages = Object.keys(state.messages).length;
  metrics.conversations = Object.keys(state.conversations).length;
  metrics.reducerSamples = [...metrics.reducerSamples.slice(-199), duration];
}
